import { FileDTO } from '../../Domain/DTO/FileDTO';


export class FileExtendedDTO{
    Id: string
    FileId: string;
    FileDTO: FileDTO;
}